import { IState } from '../../shared/models/state';
import { Actions } from '@ngrx/effects';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CREATE_DEFAULT_CONFIGURATION_SUCCESS, CreateDefaultConfigurationAction } from './projects.action';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { LanguageService } from '../../shared/services/language.service';
import { initialConfig } from '../shared/domain/initialConfig';

@Injectable()
export class ProjectsResolve implements Resolve<any> {
  constructor(
    private store: Store<IState>,
    private action$: Actions,
    private crazyCallConfigService: CrazyCallConfigService,
    private languageService: LanguageService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const config = initialConfig(this.crazyCallConfigService.appId, this.languageService.getCookieLanguage() || 'en');
    this.store.dispatch(new CreateDefaultConfigurationAction(config));
    return this.action$.ofType(CREATE_DEFAULT_CONFIGURATION_SUCCESS).take(1);
  }
}
